<template>
    <svg class="h-5 w-5" :class="style" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" fill="currentColor" aria-hidden="true">
		<path d="M26.5,2.7l6.9,13.7l13.3,1.3c0.6,0.1,1.2,0.5,1.4,1.1c0.2,0.6,0.1,1.3-0.4,1.7L36.8,31.4l4.1,14.7
			c0.2,0.6-0.1,1.3-0.6,1.7c-0.5,0.4-1.2,0.5-1.8,0.2L25,41.4L11.5,48c-0.6,0.3-1.3,0.2-1.8-0.2c-0.5-0.4-0.7-1.1-0.6-1.7
			l4.1-14.7L2.3,20.5c-0.5-0.5-0.6-1.1-0.4-1.7c0.2-0.6,0.8-1,1.4-1.1l13.3-1.3l6.9-13.7c0.3-0.6,0.9-0.9,1.5-0.9
			C25.6,1.8,26.2,2.1,26.5,2.7z"/>
    </svg>
</template>

<script>
export default {
    props: ['style'],
    setup() {
        
    },
}
</script>